import React from 'react';
import { Icon, Modal, Text } from '@bb/elements-web';
import styled from 'styled-components';
import { TitleCircle } from '../StyledComponents';

interface CancelModalProps {
  open: boolean;
  onCancel: () => void;
}

/**
 * The modal to display confirming whether the user wants to cancel
 * their Answering Service subscription.
 */
const CancelModal: React.FC<CancelModalProps> = ({ open, onCancel }) => {
  const handleConfirmCancel = () => {
    console.log('TODO: Implement function here.');
  };
  return (
    <Modal
      open={open}
      title="Are you sure you want to cancel?"
      okText="Continue to cancel"
      cancelText="Keep Live Concierge"
      onOk={handleConfirmCancel}
      onCancel={onCancel}
      dataCy="cancel-lcs-modal"
    >
      If you cancel the Live Concierge Service, you will lose access to our live
      support for your showings immediately.
      <ServiceContainer>
        <TitleCircle>
          <Icon
            icon="liveConcierge"
            size={26}
            color="primary"
            style={{ display: 'flex' }}
          />
        </TitleCircle>
        <TextContainer>
          <StyledTitleText size="large" thickness="bold">
            Live Concierge
          </StyledTitleText>
          <StyledSubText>Concierge services</StyledSubText>
        </TextContainer>
      </ServiceContainer>
    </Modal>
  );
};

export default CancelModal;

const ServiceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 1em;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledSubText = styled(Text)`
  font-size: 16px;
`;

const StyledTitleText = styled(Text)`
  font-size: 20px;
`;
